export enum UserRoleEnum {
  supervisor = 'SUPERVISOR',
  monitor = 'MONITOR',
}
